import {ApplicationConfig, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {providePrimeNG} from 'primeng/config';
import Aura from '@primeng/themes/aura';
import {KeycloakAngularModule, KeycloakService} from 'keycloak-angular';
import {routes} from './app.routes';
import {APP_INITIALIZER} from '@angular/core';
import {initializeKeycloak} from './utils/keyclockInit/keycloackInit';
import {environment} from './environments/environment.dev';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import MyPreset from '../preset';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng'
          },
          darkModeSelector: '.watchdog-dark',
        }
      }
    })
,
    importProvidersFrom(KeycloakAngularModule),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      deps: [KeycloakService],
      multi: true,
    },
    KeycloakService
  ]
};

